import { get, apiPrefix, post } from './common';
import { webApiResponseHandlerJSON } from './api';
const getAccountsByName = (name) => get(`${apiPrefix}/salesforce/accounts?searchQuery=${name}`).then(webApiResponseHandlerJSON);
const getAccountById = (id) => get(`${apiPrefix}/salesforce/accounts/${id}`).then(webApiResponseHandlerJSON);
const postCompany = (company) => post(`${apiPrefix}/salesforce/company`, { ...company }).then(webApiResponseHandlerJSON);
export { getAccountsByName, getAccountById, postCompany };
